if (!customElements.get('complementary-product-slider')) {
  customElements.define('complementary-product-slider', class ComplementaryProductSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.comp-track');
      this.prev  = this.querySelector('.comp-btn-prev');
      this.next  = this.querySelector('.comp-btn-next');
      if (!this.track) return;
      this._init();
    }

    _init() {
      if (this.prev) this.prev.addEventListener('click', () => {
        this.track.scrollBy({ left: -this.track.clientWidth, behavior: 'smooth' });
      });
      if (this.next) this.next.addEventListener('click', () => {
        this.track.scrollBy({ left: this.track.clientWidth, behavior: 'smooth' });
      });
      this.track.addEventListener('scroll', () => this._update(), { passive: true });
      this._update();
    }

    _update() {
      const atStart = this.track.scrollLeft < 1;
      const atEnd   = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 1;
      if (this.prev) this.prev.disabled = atStart;
      if (this.next) this.next.disabled = atEnd;
      this.classList.toggle('can-go-prev', !atStart);
    }
  });
}
